import { render, staticRenderFns } from "./MediaPackagePicker.vue?vue&type=template&id=60a94ce0&"
import script from "./MediaPackagePicker.vue?vue&type=script&lang=ts&"
export * from "./MediaPackagePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports